import axios from 'axios';
import authHeader from "@/service/auth-header";

class ClaimService {

    async getClaimsByCompany(companyId) {
        console.log("[ClaimService][getClaimsByUser] Before getting claims for company. Company ID = ", companyId);
        return await axios.get(`/api/claim/${companyId}`, {headers: authHeader()})
    }

    async getClaimsByPractitioner(practitionerId) {
        console.log("[ClaimService][getClaimsByPractitioner] Before getting claims for practitioner. Practitioner ID = ", practitionerId);
        return await axios.get(`/api/claim/practitioner/${practitionerId}`, {headers: authHeader()})
    }

    async getClaimsByInvoice(invoiceId) {
        console.log("[ClaimService][getClaimsByInvoice] Before getting claims for invoice. Invoice ID = ", invoiceId);
        return await axios.get(`/api/claim/invoice/${invoiceId}`, {headers: authHeader()})
    }

    async getClaim(claimId) {
        console.log("[ClaimService][getClaim] Before getting claim. Claim ID = ", claimId);
        return await axios.get(`/api/claim/specific/${claimId}`, {headers: authHeader()})
    }

    async createClaim(invoiceId, healthInsuranceSubmissionMethodResponse, useTaxRate) {
        console.log("[ClaimService][createClaim] Before creating claim. Invoice ID = ", invoiceId);
        return await axios.post(`/api/claim/${invoiceId}/${healthInsuranceSubmissionMethodResponse}/${useTaxRate}`, null, {headers: authHeader()});
    }

    async updateClaim(claimId, data) {
        console.log("[ClaimService][updateClaim] Before updating claim. Data = ", data);
        return await axios.put(`/api/claim/${claimId}`, data, {headers: authHeader()});
    }

    async deleteClaim(claimId) {
        console.log("[ClaimService][deleteClaim] Before deleting claim. Claim ID = ", claimId);
        return await axios.delete(`/api/claim/${claimId}`, {headers: authHeader()});
    }

    async createClaimSubmissionByEmail(claimId, resubmissionResponse, formData) {
        // console.log("[ClaimService][createClaimSubmissionByEmail] Before creating claim submission by email. Claim ID = ", claimId);
        // return await axios.post(`/api/claim/submission/email/${claimId}/${resubmissionResponse}`, null, {headers: authHeader()});
        return await axios.post(`/api/claim/submission/email/${claimId}/${resubmissionResponse}`,
            formData,
            {headers: authHeader(), "Content-Type": "multipart/form-data"});
    }

    async createClaimSubmissionByEdi(claimId) {
        console.log("[ClaimService][createClaimSubmissionByEdi] Before creating claim submission by EDI. Claim ID = ", claimId);
        return await axios.post(`/api/claim/submission/edi/${claimId}`, null, {headers: authHeader()});
    }

    async createClaimBenefitCheckByEdi(claimId) {
        console.log("[ClaimService][createClaimBenefitCheckByEdi] Before creating claim benefit check by EDI. Claim ID = ", claimId);
        return await axios.post(`/api/claim/benefitcheck/edi/${claimId}`, null, {headers: authHeader()});
    }

    async createUnlinkedClaimBenefitCheckByEdi(companyId, providerId, billingPlanId, memberNumber) {
        return await axios.post(`/api/claim/benefitcheck/edi/unlinked/${companyId}/${providerId}/${billingPlanId}/${memberNumber}`, null, {headers: authHeader()});
    }

    async createClaimReversal(claimId) {
        console.log("[ClaimService][createClaimReversal] Before creating claim reversal. Claim ID = ", claimId);
        return await axios.post(`/api/claim/reversal/${claimId}`, null, {headers: authHeader()});
    }

    async getCompanyClaimsLazyLoading(companyId, params, search, filters, start, end) {
        try {
            const newParams = {};

            newParams.sort  = params.sortField || 'id';
            newParams.order = params.sortOrder === 1 ? 'asc' : 'desc';

            newParams.page = params.first / params.rows + 1;
            newParams.size = params.rows;

            if (search) {
                newParams.search = search;
            }

            if (filters) {
                newParams.filters = filters;
            }

            if (start) {
                newParams.start = new Date(start).toISOString();
            }

            if (end) {
                newParams.end = new Date(end).toISOString();
            }

            var apiString = `/api/claim/lazyloading/${companyId}`;

            console.log("[ClaimService][getCompanyClaimsLazyLoading] ",
                "page =", newParams.page,
                ", size =", newParams.size,
                ", sort =", newParams.sort,
                ", order =", newParams.order,
                ", search =", newParams.search,
                ", filters =", newParams.filters,
                ", start =", newParams.start,
                ", end =", newParams.end,
                ", API =", apiString);

            const response = await axios.get(apiString, {
                headers: authHeader(),
                params: newParams
            });

            return {
                data: response.data,
                totalRecords: response.totalElements
            };
        } catch (error) {
            console.error("[ClaimService][getCompanyClaimsLazyLoading] API Error = ", error);
            return { data: [], totalRecords: 0 };
        }
    }


    async getCompanyPractitionerClaimsLazyLoading(companyId, practitionerId, params, search, filters, start, end) {
        try {
            const newParams = {};

            newParams.sort  = params.sortField || 'id';
            newParams.order = params.sortOrder === 1 ? 'asc' : 'desc';

            newParams.page = params.first / params.rows + 1;
            newParams.size = params.rows;

            if (search) {
                newParams.search = search;
            }

            if (filters) {
                newParams.filters = filters;
            }

            if (start) {
                newParams.start = new Date(start).toISOString();
            }

            if (end) {
                newParams.end = new Date(end).toISOString();
            }

            var apiString = `/api/claim/practitioner/lazyloading/${companyId}/${practitionerId}`;

            console.log("[ClaimService][getCompanyPractitionerClaimsLazyLoading] ",
                "page =", newParams.page,
                ", size =", newParams.size,
                ", sort =", newParams.sort,
                ", order =", newParams.order,
                ", search =", newParams.search,
                ", filters =", newParams.filters,
                ", start =", newParams.start,
                ", end =", newParams.end,
                ", API =", apiString);

            const response = await axios.get(apiString, {
                headers: authHeader(),
                params: newParams
            });

            return {
                data: response.data,
                totalRecords: response.totalElements
            };
        } catch (error) {
            console.error("[ClaimService][getCompanyPractitionerClaimsLazyLoading] API Error = ", error);
            return { data: [], totalRecords: 0 };
        }
    }

}

export default new ClaimService();
